import { OnboardingWelcomeDialog } from "@/components/OnboardingWelcomeDialog";
import { withMessageInputContext } from "@/context/MessageInputContext";
import { withSessionProvider } from "@/context/SessionContext";
import React from "react";
import { HomeSurface } from "./HomeSurface";

/**
 * Browser-style home page (canvas-centric `/` behind the `newHomePage` flag):
 * the unscoped `HomeSurface` — greeting + composer above a Recents / Canvases /
 * Chats / Starred browser. The workspace detail page renders the same surface
 * scoped to one workspace. The finish-onboarding CTA lives inside the browser,
 * not here; the full-screen welcome dialog below is for never-started users.
 */
const HomePageInner: React.FC = withSessionProvider(() => {
  return (
    <>
      <title>{import.meta.env.VITE_DEFAULT_APP_TITLE}</title>
      <HomeSurface />
      <OnboardingWelcomeDialog />
    </>
  );
});

export const HomePage = withMessageInputContext(HomePageInner);
